import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 1. 导入语言包
import zh from '../../lang/zh_cn'
import en from '../../lang/en_us'

// 2. 创建带选项的 VueI18n 实例
const i18n = new VueI18n({
  // 设置默认语言，尝试从本地存储读取，没有则用中文
  locale: localStorage.getItem('locale-lang') || 'zh-CN',
  // 3. 注册语言包
  messages: {
    zh,
    en
  }
})

// 4. 导出实例，以便在main.js和使用
export default i18n